import React, { Suspense, useEffect, useState } from "react";
import "./terms.scss";
import Header from "../components/landing/header/Header";
import Footer from "../components/landing/footer/Footer";
import { useSelector } from "react-redux";
import useScrollUp from "../hooks/useScrollUp";
import ButtonUp from "../components/mui/button_up/ButtonUp";
import PageWitchMenu from "../components/mui/page_witch_menu/PageWitchMenu";
import { API_CASINO } from "../api/casino";

export default function Terms() {
  useScrollUp();
  const lang = useSelector((state) => state.common.lang);
  const siteName = useSelector((state) => state.common.casinoName);

  const [text, setText] = useState("");

  const insertText = text
    .replaceAll("{name_of_casino}", `<b>${siteName}</b>`)
    .replaceAll("&nbsp;", " ");

  useEffect(() => {
    API_CASINO.agreement({ lang })
      .then((e) => {
        const text = e.data.text;
        if (text) setText(text);
      })
      .catch(console.error);
  }, [lang]);

  return (
    <PageWitchMenu className={"terms"}>
      <Header />
      <Suspense>
        <div className="terms__content" dangerouslySetInnerHTML={{ __html: insertText }}></div>
      </Suspense>
      <ButtonUp />
      <Footer />
    </PageWitchMenu>
  );
}
